import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// components
import Logo from '../../components/logo';

// ----------------------------------------------------------------------

const StyledHeader = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'sticky',
  zIndex: 1000,
  backgroundColor: '#fff',
  borderBottom: '1px solid #f0f0f0',
  padding: theme.spacing(2, 2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2.5, 3),
  },
}));

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  return (
    <>
      <StyledHeader>
        <Logo />
      </StyledHeader>

      <Box sx={{ width: '100%', minHeight: 'calc(100vh - 80px)' }}>
        <Outlet />
      </Box>
    </>
  );
}
